import NewWellApprove from '../edit/approval'
import { useWellState } from '../../../../context/well-context'
import NewWellSubmissionWrapped from '../../../../components/wells/submission'

export default function ViewSubmissionPage() {
  const { wellState } = useWellState()

  return wellState?.isUnderReview || wellState?.isPublished ? <NewWellApprove /> : <NewWellSubmissionWrapped />
}
